import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { RegisterModel } from '../models/legacy';
import { SpinnerService } from '../shared-new/services/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  public baseUrl = environment.apiAuthUrl;
  public onError: BehaviorSubject<string> = new BehaviorSubject('');
  public serviceParameter = {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    Authorization: '',
  };

  public constructor(private readonly http: HttpClient, private spinnerService: SpinnerService) {}

  public register(user: RegisterModel): Observable<RegisterModel> {
    this.spinnerService.popRequest('register');
    return this.http.post<RegisterModel>(`${this.baseUrl}/register`, user).pipe(
      map((res) => {
        this.spinnerService.popRequest('register');
        return res;
      }),
      catchError((error: Error) => {
        this.onError.next(error.message);
        this.spinnerService.popRequest('register');
        return throwError(error);
      })
    );
  }

  public isUserNameTaken(email: string): Observable<{}> {
    this.spinnerService.popRequest('isUserNameTaken');
    return this.http
      .post(`${this.baseUrl}/register/IsUserNameAlreadyExists`, `"${email}"`, {
        withCredentials: false,
        observe: 'response',
        headers: this.serviceParameter,
      })
      .pipe(
        map((res) => {
          this.spinnerService.popRequest('isUserNameTaken');
          return res.body;
        }),
        catchError((error: Error) => {
          this.onError.next(error.message);
          this.spinnerService.popRequest('isUserNameTaken');
          return throwError(error);
        })
      );
  }

  public resendVerificationEmail(email: string): Observable<{}> {
    this.spinnerService.popRequest('resendVerificationEmail');
    return this.http
      .get(`${this.baseUrl}/register/${email}/resendVerification`)
      .pipe(
        map((res) => {
          this.spinnerService.popRequest('resendVerificationEmail');
          return res;
        }),
        catchError((error: Error) => {
          this.onError.next(error.message);
          this.spinnerService.popRequest('resendVerificationEmail');
          return throwError(error);
        })
      );
  }
}
